import { WhatsAppActiveLocale } from 'modules/domains/template/types/locale';
import { MetaApprovalStatusDefinition } from 'modules/graphql/types/GraphQLTemplate';
import { useMemo } from 'react';

export const useHasActiveWhatsAppLocaleMatchingStatus = (
  activeWhatsAppTemplateLocales: WhatsAppActiveLocale[] = [],
  status: MetaApprovalStatusDefinition,
) => {
  return useMemo(
    () =>
      !!activeWhatsAppTemplateLocales?.some(
        (activeWhatsAppTemplateLocale) =>
          activeWhatsAppTemplateLocale?.metaApprovalStatus &&
          activeWhatsAppTemplateLocale?.metaApprovalStatus === status,
      ),

    [activeWhatsAppTemplateLocales, status],
  );
};
